const B3_TIME_ZONE = 'America/Sao_Paulo';

export function getClockParts(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: B3_TIME_ZONE,
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(now);
  const get = type => parts.find(part => part.type === type)?.value;
  return {
    weekday: get('weekday'),
    date: `${get('year')}-${get('month')}-${get('day')}`,
    hour: Number(get('hour')),
    minute: Number(get('minute')),
  };
}

export function getNextOptionsUpdate(now = new Date(), callsToday = 0) {
  const clock = getClockParts(now);
  if (Number(callsToday) >= 64) {
    return clock.weekday === 'Fri' ? 'segunda-feira às 10:00' : 'amanhã às 10:00';
  }
  if (clock.weekday === 'Sat' || clock.weekday === 'Sun') {
    return 'segunda-feira às 10:00';
  }
  if (clock.hour < 10) {
    return '10:00';
  }
  if (clock.hour >= 10 && clock.hour < 17) {
    return `${String(clock.hour + 1).padStart(2, '0')}:00`;
  }
  if (clock.hour === 17) {
    return '18:10';
  }
  return clock.weekday === 'Fri' ? 'segunda-feira às 10:00' : 'amanhã às 10:00';
}
